module.exports = __webpack_public_path__ + "front/img/p15.19b7b82f.png";